export default {
  en: {
    project: {
      searchCode: 'Search by project'
    },
    file: {
      files: 'Files',
      fileName: 'File name',
      returnToRepositoryRoot: 'Return to the repository root',
      content: 'Content',
      code: 'Code',
      preview: 'Preview',
      wrapLines: 'Wrap Lines',
      doNotWrapLines: 'Do not Wrap Lines',
      raw: 'Raw File',
      download: 'Download',
      deleteWarning: 'When deleting a file, the {0} folder will also be deleted',
      deleted: 'Delete file ',
      returnToFileView: 'Return to file view',
      addFiles: 'Add Files',
      createBranch: 'Create branch',
      createFile: 'Create File',
      uploadFiles: 'Upload Files',
      noFiles: 'No Files',
      switchToBranchToAddFiles: 'Switch to the branch to add files',
      notEnoughPermissions: 'Not enough permissions to add files',
      sizeMessage: 'the size of all files cannot exceed 100Mb',
      addedFiles: 'Add Files ',
      added: 'Add File ',
      edit: 'Edit File',
      delete: 'Delete File',
      deleteQuestion: 'Are you sure you want to delete this file?',
      switchToBranchToEditFile: 'Switch to a branch to edit a file',
      notEnoughPermissionsToEditFile: 'Not enough permissions to edit a file',
      blockedByAnotherUser: 'File is blocked by another user',
      switchToBranchToDeleteFile: 'Switch to a branch to delete a file',
      notEnoughPermissionsToDeleteFile: 'Not enough permissions to delete a file',
      lfsIsNotEditable: 'LFS files are not editable',
      file_locked_by: 'Locked by'
    },
    directory: {
      deleteWarning: 'If you delete the {0} directory, all of its contents will be deleted',
      deleteMessage: 'Delete a directory ',
      deleteQuestion: 'Are you sure you want to delete this directory?'
    },
    commit: {
      lastCommit: 'Last commit',
      time: 'Commit time',
      older: 'Older',
      newer: 'Newer',
      message: 'Commit message',
      directlyInBranch: 'Commit directly in the branch',
      inNewBranch: 'Create a new branch for this commit',
      push: 'Push',
      banPush: 'You do not have enough rights to push <b>{currentBranch}<b>',
      messageActions: {
        updateAndRename: 'Update and rename {0} to {1}',
        rename: 'Rename {0} to {1}',
        update: 'Update '
      },
      create: 'Create Commit'
    },
    blame: {
      revs: {
        ignoring: 'Ignoring revisions in '
      },
      prior: {
        message: 'Blame prior to change {commitHash}'
      }
    }
  },
  ru: {
    project: {
      searchCode: 'Поиск по проекту'
    },
    file: {
      files: 'Файлы',
      fileName: 'Имя файла',
      returnToRepositoryRoot: 'Вернуться к корню репозитория',
      content: 'Содержимое',
      code: 'Код',
      preview: 'Предпросмотр',
      wrapLines: 'Переносить строки',
      doNotWrapLines: 'Не переносить строки',
      raw: 'Исходное содержание',
      download: 'Скачать',
      deleteWarning: 'При удалении файла будет также удалена папка {0}',
      deleted: 'Удален файл ',
      returnToFileView: 'Вернуться к просмотру файла',
      addFiles: 'Добавить файлы',
      createBranch: 'Создать ветку',
      createFile: 'Создать файл',
      uploadFiles: 'Загрузить файлы',
      noFiles: 'Нет файлов',
      switchToBranchToAddFiles: 'Переключитесь в ветку, чтобы добавить файлы',
      notEnoughPermissionsToAddFiles: 'Недостаточно прав для добавления файлов',
      sizeMessage: 'размер всех файлов не может превышать 100Mb',
      addedFiles: 'Добавлены файлы ',
      added: 'Добавлен файл ',
      edit: 'Редактировать файл',
      delete: 'Удалить файл',
      deleteQuestion: 'Вы уверены, что хотите удалить файл?',
      switchToBranchToEditFile: 'Переключитесь в ветку, чтобы редактировать файл',
      notEnoughPermissionsToEditFile: 'Недостаточно прав для редактирования файла',
      blockedByAnotherUser: 'Файл заблокирован другим пользователем',
      switchToBranchToDeleteFile: 'Переключитесь в ветку, чтобы удалить файл',
      notEnoughPermissionsToDeleteFile: 'Недостаточно прав для удаления файла',
      lfsIsNotEditable: 'Редактирование LFS файлов запрещено',
      file_locked_by: 'Заблокирован пользователем'
    },
    directory: {
      deleteWarning: 'При удалении директории {0} будет удалено все ее содержимое',
      deleteMessage: 'Удалена директория ',
      deleteQuestion: 'Вы уверены, что хотите удалить директорию?'
    },
    commit: {
      lastCommit: 'Сообщение последнего коммита',
      time: 'Время коммита',
      older: 'Старые',
      newer: 'Новые',
      message: 'Сообщение коммита',
      directlyInBranch: 'Коммит в текущую ветку',
      inNewBranch: 'Создать новую ветку для этого коммита',
      push: 'Отправить изменения',
      banPush: 'У вас недостаточно прав для push в <b>{currentBranch}</b>',
      messageActions: {
        updateAndRename: 'Обновлен и переименован файл с {0} на {1}',
        rename: 'Переименован файл с {0} на {1}',
        update: 'Обновлен файл '
      },
      create: 'Создать коммит'
    },
    blame: {
      revs: {
        ignoring: 'Игнорируются изменения из '
      },
      prior: {
        message: 'Просмотр последней версии <br> {commitHash} до данного изменения'
      }
    }
  }
};
